<div class="clearfix">
  <div class="captcha-wrap">
    <span class="mb-3 d-block">{{ label }}</span>
    <div class="row no-gutters">
      <div class="captcha-reset">
        <span class="btn-link cursor-pointer float-end" (click)="resetCaptcha()"><span
            class="icon icon-refresh"></span></span>
      </div>
      <div class="col-6 captcha-img">
        <img class="captcha" src="{{ requestCaptcha?.image }}" />
      </div>
      <div class="col p-0">
        <!-- <form-help [hidden]="!help">{{ help }}</form-help> -->
        <input class="input-control" [formControl]="control" type="text" [placeholder]="placeholder"
          [attr.aria-label]="placeholder" />
        <div class="help-text">
          <ng-content select="[helpText]"></ng-content>
        </div>
      </div>
    </div>
  </div>
  <!-- {{showErrors}} {{control?.touched}} {{control?.invalid}} -->
  <!-- <form-validation [class.show]="(showErrors || control?.touched) && control?.invalid">
    <ng-content></ng-content>
  </form-validation> -->
</div>